import HistoricalPage from "./HistoricalPage";
export default HistoricalPage;
